const PropTypes = require('prop-types');
const React = require('react');
const Spinner = require('components/shared/spinner');
const APIRequest = require('components/api_request');

const DELAY_MILLISECONDS = 1000;

class AsyncLoader extends React.Component {
  constructor(props) {
    super(props);
    this.handleResponse = this.handleResponse.bind(this);
    this.delayedCheckStatus = this.delayedCheckStatus.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
  }

  componentDidMount() {
    this.delayedCheckStatus();
  }

  delayedCheckStatus() {
    this.window.setTimeout(this.checkStatus, DELAY_MILLISECONDS);
  }

  checkStatus() {
    APIRequest.get(this.props.statusPollingPath).then(
      this.handleResponse
    ).fail(this.delayedCheckStatus);
  }

  handleResponse(response) {
    if (response.complete) {
      this.window.location.href = response.redirect_path;
    } else {
      this.delayedCheckStatus();
    }
  }

  get window() {
    // fake window for testing
    return (this.props.window || window);
  }

  render() {
    return (
      <div className="async-loader">
        <p className="async-loader__title">
          {this.props.descriptionText}
        </p>
        <Spinner size="large" />
        <p className="async-loader__description">
          {I18n.t('js.asyncLoader.oneMomentPlease')}
        </p>
      </div>
    );
  }
}

AsyncLoader.propTypes = {
  statusPollingPath: PropTypes.string.isRequired,
  descriptionText: PropTypes.string,
  window: PropTypes.object,
};

module.exports = AsyncLoader;



// WEBPACK FOOTER //
// ./javascripts/components/async_loader.jsx